'use strict';

import type { UserLog } from '../../Entities/User/UserLog';
import { EntityCollection } from '../EntityCollection';

export class UserLogCollection extends EntityCollection<UserLog> {}
